<div
  class="py-1 px-2 border-round-lg flex align-items-center"
  [ngClass]="[backgroundColour, textColour]"
>
  <ng-content></ng-content>
</div>
